require('bootstrap/js/src/util.js');
require('bootstrap/js/src/alert.js');
require('bootstrap/js/src/collapse.js');
require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/scrollspy.js');
require('bootstrap/js/src/tab.js');
require('bootstrap/js/src/tooltip.js');

$(document).on('click', '.modal-backdrop', function () {
    if ($('.modal').length) {
        $('.modal').modal('hide');
    }
});
